import { Button, ButtonContainer } from '@vwfs-bronson/bronson-react';
import { useDispatch } from 'react-redux';

import { addNotificationSuccess } from '../../actions/notificationAction';
import { JsonViewer } from '../JsonViewer/JsonViewer.jsx';
import { Section } from './Section.jsx';

const getLinkForCurrentEnvironment = (url) => {
  if (!url || !import.meta.env.DEV) {
    return url;
  }

  const hashIndex = url.indexOf('#');
  if (hashIndex < 0) {
    return url;
  }

  const hashPart = url.slice(hashIndex + 1);
  const normalizedHash = hashPart.startsWith('/') ? hashPart : `/${hashPart}`;

  return `${window.location.origin}/#${normalizedHash}`;
};

export const GeneratedJsonPanel = ({
  configuration,
  onGenerateLink,
  onReset,
  isGeneratingLink,
  generatedLink,
  generatedLinkError,
}) => (
  <div
    style={{
      position: 'sticky',
      top: '1rem',
      alignSelf: 'flex-start',
      maxHeight: 'calc(100vh - 2rem)',
      overflow: 'auto',
    }}
  >
    <Section title="JSON generado">
      <div style={{ maxHeight: '55vh', overflow: 'auto' }}>
        <JsonViewer data={configuration} />
      </div>
      <ButtonContainer style={{ display: 'flex', justifyContent: 'center', gap: '0.5rem' }}>
        <Button onClick={onGenerateLink} disabled={isGeneratingLink}>
          {isGeneratingLink ? 'Generando...' : 'Generar Link'}
        </Button>
        <Button secondary onClick={onReset} disabled={isGeneratingLink}>
          Resetear valores
        </Button>
      </ButtonContainer>
    </Section>

    {generatedLink && (
      <Section title={'Link Generado'} >
        {generatedLink && <FormGeneratedLink generatedLink={generatedLink} />}

        {generatedLinkError && <p className="u-mt-small u-mb-none">{generatedLinkError}</p>}
      </Section>
    )}
  </div>
);

const FormGeneratedLink = ({ generatedLink }) => {
  const linkForCurrentEnvironment = getLinkForCurrentEnvironment(generatedLink);

  return (
    <div className="u-mt-small">
      <div style={{ minWidth: 0 }}>
        <a
          href={linkForCurrentEnvironment}
          target="_blank"
          rel="noreferrer"
          title={linkForCurrentEnvironment}
          style={{
            display: 'block',
            width: '100%',
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {linkForCurrentEnvironment}
        </a>
      </div>

      <div className="u-mt-xsmall" style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
        <CopyReturnUrlButton generatedLink={linkForCurrentEnvironment} />
        <OpenLinkButton generatedLink={linkForCurrentEnvironment} />
      </div>
    </div>
  );
};

const CopyReturnUrlButton = ({ generatedLink }) => {
  const dispatch = useDispatch();

  const handleCopyResponse = async () => {
    if (!navigator?.clipboard) {
      return;
    }

    await navigator.clipboard.writeText(generatedLink);
    dispatch(addNotificationSuccess('Link copiado correctamente'));
  };

  return (
    <Button icon="semantic-copy" small onClick={handleCopyResponse} title="Copiar" aria-label="Copiar">
      Copiar
    </Button>
  );
};

const OpenLinkButton = ({ generatedLink }) => (
  <Button
    icon="semantic-forward"
    small
    onClick={() => window.open(generatedLink, '_blank', 'noopener,noreferrer')}
    title="Abrir"
    aria-label="Abrir"
  >
    Abrir
  </Button>
);
